import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { FormItemUiDefinition } from '../../../../types/formItem.ts';
import { getUiDefinitionContainerStyles, getUiDefinitionTextStyles } from '../../../../utils/styles.ts';
import { ItemContainer } from '../../ItemContainer.tsx';
import { FileCardsGrid } from './FileUpload/components/FileCardsGrid';
import { FilePreviewPopover } from './FileUpload/components/FilePreviewPopover';
import { useFilePreviewPopover } from './FileUpload/hooks/useFilePreviewPopover';
import { useFlowFilesData } from './FileUpload/hooks/useFlowFilesData';

interface Props {
  value: string[];
  formItemUiDefinition?: FormItemUiDefinition;
}

const FileBase = ({ value, formItemUiDefinition }: Props) => {
  const { t } = useTranslation();
  const filesCount = value?.length || 0;
  const textStyles = getUiDefinitionTextStyles(formItemUiDefinition);
  const containerStyles = getUiDefinitionContainerStyles(formItemUiDefinition);

  const { open, anchorEl, handleMouseEnter, handleClick, scheduleClose, handlePopoverMouseEnter, closePopover, clearCloseTimeout } =
    useFilePreviewPopover({ filesCount });

  const { filesData, isFetching } = useFlowFilesData({
    ids: value ?? [],
    skip: !open,
  });

  return (
    <ItemContainer styles={containerStyles}>
      <FilePreviewPopover
        label={`${t('common.count')}: ${filesCount}`}
        open={open}
        anchorEl={anchorEl}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={scheduleClose}
        onClick={handleClick}
        onPopoverMouseEnter={handlePopoverMouseEnter}
        onClose={closePopover}
        triggerSx={textStyles}>
        <FileCardsGrid files={filesData} isLoading={isFetching} disabledRemove onOpenPreview={clearCloseTimeout} />
      </FilePreviewPopover>
    </ItemContainer>
  );
};

export const File = memo(FileBase) as typeof FileBase;
